import * as z from "zod";

const ledBoardModeEnum = ["blocked", "stat_tracking", "umpire_assist"] as const;
const ageGroupEnum = [
  "8U",
  "9U",
  "10U",
  "11U",
  "12U",
  "13U",
  "14U",
  "15U",
  "16U",
  "17U",
  "18U",
  "College",
  "Pro",
] as const;

export const fieldConfigurationSchema = z.object({
  sport: z.enum(["baseball", "softball"], {
    required_error: "Sport is required",
  }),
  level: z
    .enum(ageGroupEnum, { required_error: "Level is required" })
    .optional(),
  moundDistance: z.coerce
    .number({ required_error: "Mound distance is required" })
    .positive("Mound distance must be positive"),
  baseDistance: z.coerce.number().positive("Must be greater than 0"),
  infieldAtFoulLine: z.coerce.number().positive("Must be greater than 0"),
  fenceFirstBase: z.coerce.number().positive("Must be greater than 0"),
  fenceThirdBase: z.coerce.number().positive("Must be greater than 0"),
  leftField: z.coerce.number().positive("Must be greater than 0"),
  centerField: z.coerce.number().positive("Must be greater than 0"),
  rightField: z.coerce.number().positive("Must be greater than 0"),
  strikeZone: z.object(
    {
      name: z.string(),
      bottomInches: z.number(),
      topInches: z.number(),
      sideFromCenterInches: z.number(),
      strikeZoneYInches: z.number().optional(),
      topIncludedExpansionInches: z.number().optional(),
      bottomIncludedExpansionInches: z.number().optional(),
      sideFromCenterIncludedExpansionInches: z.number().optional(),
      ageGroup: z.enum(ageGroupEnum).nullable().optional(),
    },
    { required_error: "Average batter height is required" },
  ),
  ledBoardMode: z.enum(ledBoardModeEnum).nullable(),
  ledEndTimeISO: z.string().nullable().optional(),
  ledOrgId: z.string().nullable().optional(),
});

export type FieldConfigurationFormValues = z.infer<
  typeof fieldConfigurationSchema
>;
